import { css } from '@emotion/css'

export const container = css`
  width: 100%;
`
export const linkContainer = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  text-align: left;
`
